/**
 * RULES
 *  1. use uppercase
 *  2. use lowercase if end-point have sub routes
 */
export const REST_API = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  REGISTER: 'registration_request',

  TICKET_CREATE: 'ticket/create',
  TICKET_UPDATE: 'ticket/update',
  TICKET_LIST: 'ticket/list',
  TICKET_VIEW: 'ticket/view/',
  TICKET_DELETE: 'ticket/delete',
  TICKET_SEARCH: 'ticket/search',

  //
  NOTIFICATIONS: 'notifications',
  NOTIFICATION_CHECK: 'chat/notification-check',
  CHAT_SEND: 'chat/send',
  CHAT_MESSAGES: 'chat/messages/',

  //
  USER_REGISTRATION_CHECK: "user/registration-check",
  USER_LOGIN: "user/login",
  USER_OTP_VERIFICATION: "user/otp-verification",
  USER_PASSWORD_SET: "user/password-set",
  //
  CUSTOMER: 'customer/list',
  CUSTOMER_CREATE: 'customer/create',
  CUSTOMER_UPDATE: 'customer/update',
  CUSTOMER_EDIT_VIEW: 'customer/edit_view/',
  CUSTOMER_VIEW: 'customer/view/',
  CUSTOMER_DELETE: 'customer/deactivate/',
  CUSTOMER_SEARCH: 'category/search',

  ASSET: 'asset/list',
  ASSET_CREATE: 'asset/create',
  ASSET_UPDATE: 'asset/update',
  ASSET_EDIT_VIEW: 'asset/edit_view/',
  ASSET_VIEW: 'asset/view/',
  ASSET_DELETE: 'asset/deactivate/',
  ASSET_SEARCH: 'asset/search',

  INVOICE: 'invoice/list',

  APPOINTMENT: 'appointment/list',
  APPOINTMENT_CREATE: 'appointment/create',
  APPOINTMENT_UPDATE: 'appointment/update',
  APPOINTMENT_EDIT_VIEW: 'appointment/edit_view/',
  APPOINTMENT_VIEW: 'appointment/view/',
  APPOINTMENT_DELETE: 'appointment/deactivate/',
  APPOINTMENT_SEARCH: 'appointment/search',

  //States
  STATES_LIST: 'states',
  CITY_LIST: 'cities/',
}

export default REST_API;
